import React from 'react'
import cn from "classnames";
import { Divider } from "antd";

import styles from "./CreateMultipleTotes.module.sass"
import Modal from '../../../components/Modal';
import CustomToast from '../../../components/CustomToast';
import { EMPTY_TOTES_BY_CODES } from '../../../API/Totes';

const EmptySingleTote = ({ isModalVisible, handleModalClose, handleSuccess,toteMarkedToEmpty }) => {
    const showToast = CustomToast();

    const handleOnDeleteClick = async () => {
        try {
                const response = await EMPTY_TOTES_BY_CODES([toteMarkedToEmpty]);
                handleSuccess();
                showToast(response.message, "success");
                handleModalClose();
        }catch (error) {
            console.error("Failed to empty totes:", error);
            showToast("error", "Failed to empty totes");
        }
        
    }

    return (
        <>
            <Modal visible={isModalVisible} onClose={handleModalClose}>
                <div className={styles.details}>
                    <div className={cn("title-green", styles.title)}>
                        Confirm Empty
                    </div>
                    <Divider />
                    <div className={styles.roww}>
                        <div className={styles.coll}>
                            <p className="text-[#6F767E] pt-5">
                                Are you sure you want to Empty the tote?
                            </p>

                            <div className={cn(styles.btns)}>
                                <button
                                    type="button"
                                    className={cn("button-stroke pl-5 pr-5", styles.button)}
                                    onClick={handleModalClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={cn("button-clear-stroke button-clear-stroke-red button-small", styles.button)}
                                    onClick={handleOnDeleteClick}
                                >
                                    Empty
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default EmptySingleTote